import { render } from "./VaIconMenuCollapsed.vue?vue&type=template&id=4d5cf134"
import script from "./VaIconMenuCollapsed.vue?vue&type=script&lang=js"
export * from "./VaIconMenuCollapsed.vue?vue&type=script&lang=js"

import "./VaIconMenuCollapsed.vue?vue&type=style&index=0&id=4d5cf134&lang=scss"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__